"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const EID_BASE = 'find.sales.';
var _default = exports.default = {
  FeatureTooltipClick: 'feature-tooltip',
  llcMessageImpression: `${EID_BASE}llcMessage.impression`,
  llcMessageAffiliateClick: `${EID_BASE}llcMessage.affiliate.click`,
  llcMessageTooltipClick: `${EID_BASE}llcMessage.tooltip.click`
};